// extracted by mini-css-extract-plugin
export default {"nav_link":"Navigation_nav_link__NlXA+"};